/**
 * Creates a debounced version of a function that delays execution
 * until after the specified wait time has elapsed since the last call.
 *
 * @param callback - The function to debounce
 * @param wait - The number of milliseconds to delay (default: 250)
 * @returns A debounced version of the function
 */
export const debounce = <TArgs extends unknown[], TReturn = void>(
  callback: (...args: TArgs) => TReturn,
  wait = 250
) => {
  let timeoutId: ReturnType<typeof setTimeout> | undefined = undefined;

  return (...args: TArgs): void => {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      callback(...args);
    }, wait);
  };
};
